/**
 * Indicador de orden para el texto de un encabezado de tabla que se puede pulsar para ordenar.
 *
 * - Columna ordenada ascendente: ▲
 * - Columna ordenada descendente: ▼
 * - Columna ordenable que aún no se usa para ordenar: ⇅ (tenue), para que se note que el
 *   encabezado se puede pulsar.
 *
 * @param {{ key: string|null, direction: 'asc'|'desc' }} sortConfig - Orden actual de la tabla.
 * @param {string} columnKey - Clave de la columna a la que pertenece el encabezado.
 */
const SortIndicator = ({ sortConfig, columnKey }) => {
  if (sortConfig?.key === columnKey) {
    return <span>{sortConfig.direction === 'asc' ? ' ▲' : ' ▼'}</span>
  }

  return <span className='Tables__Table__SortIcon'>{' ⇅'}</span>
}

export { SortIndicator }
